// Central helper so every place that shows the brand logo pulls the latest
// admin-uploaded file. Falls back to the packaged /logo.png if the backend
// hasn't rendered one yet. Cache-busts with the version returned by
// GET /api/company.
import { useEffect, useState } from "react";
import { api } from "./api";

const API = process.env.REACT_APP_BACKEND_URL;
export const DEFAULT_LOGO = "/logo.png";

let cachedVersion = null;
let cachedPromise = null;

/** URL suitable for `<img src>` — always hits the backend so the newest
 *  uploaded logo is served, with a version query for cache busting. */
export function logoUrlFor(version) {
  if (!API) return DEFAULT_LOGO;
  return `${API}/api/company/logo${version ? `?v=${version}` : ""}`;
}

/** React hook that fetches the current logo version once and returns the
 *  URL. Fresh uploads bump the version so <img> re-fetches. Any component
 *  can trigger a refresh by calling `refresh()`. */
export function useBrandLogo() {
  const [version, setVersion] = useState(cachedVersion);
  useEffect(() => {
    if (cachedVersion !== null) return;
    if (!cachedPromise) {
      cachedPromise = api.get("/company").then(r => {
        cachedVersion = r.data?.logo_version || 0;
        return cachedVersion;
      }).catch(() => { cachedVersion = 0; return 0; });
    }
    cachedPromise.then(v => setVersion(v));
  }, []);
  const refresh = (v) => { cachedVersion = v || Date.now(); setVersion(cachedVersion); };
  return { logoUrl: logoUrlFor(version), version, refresh };
}
